import { Volume2, VolumeX } from "lucide-react";
import { useEffect, useRef, useState } from "react";

export function SupplyDropVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = async () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !muted;
    setMuted(video.muted);
    if (!video.muted) {
      try {
        await video.play();
      } catch {
        setMuted(true);
        video.muted = true;
      }
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;
    // iPad/Safari + strict desktop policies need muted on the element itself
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    const kick = () => video.play().catch(() => {});
    video.addEventListener("canplay", kick, { once: true });
    kick();
    // re-kick when the tab comes back into view or the gate lifts
    const relaunch = () => {
      if (!document.hidden) videoRef.current?.play().catch(() => {});
    };
    window.addEventListener("dolo-radio-autostart", relaunch);
    document.addEventListener("visibilitychange", relaunch);
    return () => {
      video.removeEventListener("canplay", kick);
      window.removeEventListener("dolo-radio-autostart", relaunch);
      document.removeEventListener("visibilitychange", relaunch);
    };
  }, []);

  return (
    <div className="supply-drop-video" data-testid="supply-drop-video">
      <div className="supply-drop-video-frame">
        <video
          ref={videoRef}
          poster="/assets/supply-drop-poster.jpg"
          className="cover-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="Radioactive Dust — official supply drop promo video"
          data-testid="supply-drop-video-player"
        >
          <source src="/assets/supply-drop-video.webm" type="video/webm" />
          <source src="/assets/supply-drop-video.mp4" type="video/mp4" />
        </video>
        <button
          type="button"
          className="video-mute-button"
          onClick={toggleMute}
          data-testid="supply-drop-video-mute-button"
          aria-label={muted ? "Unmute supply drop video" : "Mute supply drop video"}
          aria-pressed={!muted}
        >
          {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          <span>{muted ? "MUTED" : "SOUND ON"}</span>
        </button>
      </div>
      <span className="supply-drop-video-tag" data-testid="supply-drop-video-tag">SUPPLY DROP TRANSMISSION // RADIOACTIVE DUST</span>
    </div>
  );
}
